import React, { useContext, memo, Fragment, useMemo } from 'react';
import { object, string } from 'prop-types';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';

import { ImagePlaceholder } from 'components/ImagePlaceholder';
import { ImageTechDoc } from 'components/ImageTechDoc';

import { VALEO_BRANDS, getIsValeoBrand } from 'utils/constantsHelper';
import { concatCharacteristics } from 'utils/concatCharacteristics';

import { StaticTextContext } from 'context/StaticTextContext';
import { SearchContext } from 'context/SearchContext';
import { CountryContext } from 'context/CountryContext';
import { ProductContext } from 'context/ProductContext';
import { WindowSizeContext } from 'context/WindowSizeContext';

import { withErrorBoundary } from 'containers/ErrorBoundary';

import ArrowRightIcon from 'media/icons/arrow-right.icon.svg';

import styles from './PartItem.module.scss';
const cx = classNames.bind(styles);

const PartItem = memo(({ data, className }) => {
  const { labels } = useContext(StaticTextContext);
  const { currentCountry } = useContext(CountryContext);
  const { updateProductState } = useContext(ProductContext);
  const { manuId, modelId, vehicleType, carId } = useContext(SearchContext);
  const { isMobile } = useContext(WindowSizeContext);

  const getLinkToProduct = () => {
    const { articleId, articleLinkId } = data.directArticle;

    if (manuId && modelId && articleLinkId) {
      return {
        pathname: `/product/${articleId}/about`,
        search: `?modId=${modelId}&manuId=${manuId}&linkingTargetId=${carId}&articleLinkId=${articleLinkId}&country=${currentCountry}&vehicleType=${vehicleType}`,
      };
    } else {
      return {
        pathname: `/product/${articleId}/about`,
        search: `?country=${currentCountry}`,
      };
    }
  };

  const linkToProduct = getLinkToProduct();
  const saveProduct = (event) => {
    updateProductState(null);
  };
  const {brandNo} = data.directArticle.brandNo
  const isValeoProduct = useMemo(() => getIsValeoBrand(VALEO_BRANDS, brandNo), [VALEO_BRANDS, brandNo]);
  const attributes = data.articleAttributes
    ? concatCharacteristics(data.articleAttributes.array)
    : [];

  return (
    <article
      className={cx(className, 'product', { 'valeo-product': isValeoProduct })}
    >
      <div className={cx('left-column')}>
        <div className={cx('product-img')}>
          {data.articleThumbnails && data.articleThumbnails.array ? (
            <ImageTechDoc
              id={data.articleThumbnails.array[0].thumbDocId}
              alt={data.directArticle.articleName}
            />
          ) : (
            <ImagePlaceholder className={cx('placeholder-icon')} />
          )}
        </div>

        {!isMobile && (
          <Link to={linkToProduct} onClick={saveProduct} className={cx('btn')}>
            <span className={cx('btn-text')}>
              {labels.searchItemButtonText}
            </span>
            <span className={cx('btn-icon')}>
              <ArrowRightIcon />
            </span>
          </Link>
        )}
      </div>

      {isMobile && (
        <div className={cx('details-mobile')}>
          <div className={cx('indicator')}>
            {data.directArticle.articleState === 1 ? (
              <span className={cx('text')}>
                {labels.productStatusAvailableLabel}
              </span>
            ) : (
              <span className={cx('text')}>
                {data.directArticle.articleStateName}
              </span>
            )}
          </div>
          <h2 className={cx('title')}>
            {data.directArticle.articleName} {data.directArticle.articleAddName}
          </h2>
          <div className={cx('ref-number')}>
            {labels.searchItemRefNumberLabel} : {data.directArticle.articleNo}
          </div>
          <div className={cx('ref-number')}>
            {labels.searchItemQuantityLabel} : {data.directArticle.packingUnit}
          </div>
        </div>
      )}

      <section className={cx('details')}>
        {!isMobile && (
          <div className={cx('details-desktop')}>
            <div className={cx('indicator')}>
              {data.directArticle.articleState === 1 ? (
                <span className={cx('text')}>
                  {labels.productStatusAvailableLabel}
                </span>
              ) : (
                <span className={cx('text')}>
                  {data.directArticle.articleStateName}
                </span>
              )}
            </div>
            <h2 className={cx('title')}>
              {data.directArticle.articleName}{' '}
              {data.directArticle.articleAddName}
            </h2>
            <div className={cx('ref-number')}>
              {labels.searchItemRefNumberLabel} : {data.directArticle.articleNo}
            </div>
            <div className={cx('ref-number')}>
              Quantity : {data.directArticle.packingUnit}
            </div>
          </div>
        )}

        <div className={cx('description')}>
          {attributes.map((item) => (
            <Fragment key={item.attrValueId}>
              {item.attrValue && item.attrValue.length && (
                <p>
                  <strong>{item.attrName}:</strong>
                  {' ' + item.attrValue}
                  &nbsp;
                  {item.attrUnit || ''}
                </p>
              )}
            </Fragment>
          ))}
        </div>

        {isMobile && (
          <Link to={linkToProduct} onClick={saveProduct} className={cx('btn')}>
            <span className={cx('btn-text')}>
              {labels.searchItemButtonText}
            </span>
            <span className={cx('btn-icon')}>
              <ArrowRightIcon />
            </span>
          </Link>
        )}
      </section>
    </article>
  );
});

PartItem.propTypes = {
  data: object.isRequired,
  className: string.isRequired,
};

export default withErrorBoundary(PartItem);



// WEBPACK FOOTER //
// ./src/pages/Product/components/PartItem/PartItem.js